import _ from "lodash";

import {
  Component,
} from "react";
import {
  Spinner,
  Well,
} from "CommonComponents/bricks";
import store from "CommonState/store";

@store("k_qvbgrundLookup")
export default class FinanzierungQVBHinweis extends Component {
  // Hinweis für Massnahmen mit Verwendung von QVB-Mitteln
  render() {
    const { massnahme, k_qvbgrundLookup } = this.props;

    const qvb = massnahme.massnahmeqvbgrund;

    if (_.isEmpty(qvb)) {
      return null;
    }

    if (!k_qvbgrundLookup) {
      return <Spinner />;
    }

    return (
      <Well>
        <b>Die beantragte Personalmaßnahme dient der Verbesserung der Lehre oder Studienbedingungen</b>
        <br /><br />
        <ul>{_.map(qvb, record => _.map(record.mqv_qvbgrund, g => <li key={g}>{k_qvbgrundLookup[g].kqv_text}</li>))}</ul>
      </Well>
    );
  }
}
